<template>
  <PageContainer title="Veículos">
    <div slot="header">
      <Button @handle:click="atualizarVeiculos" text="Atualizar Veículos" color="secondary">
        <Cached :size="18" />
      </Button>

      <Button v-if="canAssociarVeiculosAutonomos" @handle:click="openAssociarVeiculosModal"
        text="Cadastrar veículo de autônomo no Detran" color="primary">
        <PlusCircleOutline :size="18" />
      </Button>
    </div>

    <div class="loading" v-if="!loaded">
      <LoadingSpinner />
    </div>

    <Box v-else space="medium" class="veiculos-container">
      <form @submit.prevent="handleSubmit" class="main-form">
        <div class="inputs">
          <div class="inputs-row">
            <Select class="input-full" :options="schemaOptions" legend="Autoescola"
              placeholder="Selecione uma autoescola" :modelValue="schema"
              @update:modelValue="$event => schema = $event" :disabled="loading" />

            <Input class="input-full" legend="Placa" placeholder="Digite a placa" :modelValue="placa"
              @update:modelValue="$event => placa = $event" :disabled="loading" />

            <Input class="input-full" legend="Categoria" placeholder="Digite a categoria" :modelValue="categoria"
              @update:modelValue="$event => categoria = $event" :disabled="loading" />
          </div>
        </div>

        <div class="buttons">
          <Button type="button" @handle:click="clearInputs" text="Limpar" :fill="false" color="danger"
            :disabled="loading">
            <CloseCircleOutline :size="18" />
          </Button>

          <Button type="submit" text="Consultar" color="primary" :disabled="loading">
            <Magnify :size="18" />
          </Button>
        </div>
      </form>

      <div class="loading" v-if="loading">
        <LoadingSpinner />
      </div>

      <div class="table-container" v-else-if="veiculos.length > 0">
        <div class="table-header">
          <StatusLegend :statusOptions="statusLegendOptions" />

          <Paginate :total-pages="paginationData.lastPage" :current-page="paginationData.currentPage"
            @page-changed="fetchVeiculos" />
        </div>

        <Table :headers="schemaAutonomo
          ? ['#', 'Placa', 'Categoria', 'Detran', 'Empresa de rastreamento', 'Ações']
          : ['#', 'Placa', 'Categoria', 'Empresa de rastreamento', 'Ações']">
          <tr v-for="veiculo in veiculos" :key="veiculo.id_veiculo">
            <td>
              <BadgeCircle color="red" v-if="!veiculo.flg_ativo" />
              <BadgeCircle color="green" v-else />
            </td>
            <td>{{ veiculo.placa }}</td>
            <td>{{ veiculo.categoria_cnh }}</td>
            <td v-if="schemaAutonomo">
              <Badge v-if="veiculo.principal === true" text="Principal" color="success" />
              <template v-else-if="veiculo.principal === false">
                <Badge text="Não principal" color="warning" />
                <small class="periodo">{{ formatarPeriodo(veiculo) }}</small>
              </template>
              <Badge v-else text="Não associado" color="danger" />
            </td>
            <td>{{ veiculo.rastreamento || '-' }}</td>
            <td>
              <div class="actions">
                <div>
                  <IconButton @handle:click="openModalTrakingCompany(veiculo)" color="secondary"
                    title="Informar empresa de rastreamento" :disabled="loadingActions">
                    <MapMarkerOutline :size="19" />
                  </IconButton>
                </div>
                <div>
                  <IconButton
                    @handle:click="toggleGpsMobile(veiculo)"
                    :color="veiculo.ative_gps_apk ? 'success' : 'danger'"
                    :title="veiculo.ative_gps_apk ? 'Desativar GPS via aplicativo' : 'Ativar GPS via aplicativo'"
                    :disabled="loadingActions">
                    <CellphoneBasic :size="19" />
                  </IconButton>
                </div>
              </div>
            </td>
          </tr>
        </Table>
      </div>
    </Box>

    <updateCompanieTracking ref="trakingModal" :trakingCompanyOptions=trakingCompany :veiculo="veiculoSelected"
      :schema="schema" @load:table="fetchVeiculos" />

    <AssociarVeiculosModal v-if="canAssociarVeiculosAutonomos" ref="associarVeiculosModal" :selecionarAutonomo="true"
      @veiculoCadastrado="recarregarVeiculos" />
  </PageContainer>
</template>

<script>
import PageContainer from 'core/PageContainer'
import Box from 'core/Box'
import Button from 'core/Button'
import LoadingSpinner from 'core/LoadingSpinner'
import Select from 'core/Select'
import Input from 'core/Input'
import StatusLegend from 'core/StatusLegend'
import Paginate from 'core/Paginate'
import Table from 'core/Table'
import BadgeCircle from 'core/BadgeCircle'
import IconButton from 'core/IconButton'
import Cached from 'icons/Cached'
import Magnify from 'icons/Magnify'
import CloseCircleOutline from 'icons/CloseCircleOutline'
import MapMarkerOutline from 'icons/MapMarkerOutline'
import updateCompanieTracking from './modal/updateCompanieTracking.vue'
import CellphoneBasic from 'icons/CellphoneBasic'
import PlusCircleOutline from 'icons/PlusCircleOutline'
import Badge from 'core/Badge'
import AssociarVeiculosModal from '../../veiculos/AssociarVeiculosModal'
import { useAuth } from '@/composables/useAuth'
import { isSchemaAutonomo } from '@/constants/userRoles'

export default {
  name: 'ListarVeiculos',
  components: {
    PageContainer,
    Box,
    Button,
    LoadingSpinner,
    Select,
    Input,
    StatusLegend,
    Paginate,
    Table,
    BadgeCircle,
    IconButton,

    Cached,
    Magnify,
    CloseCircleOutline,
    MapMarkerOutline,
    CellphoneBasic,
    PlusCircleOutline,
    Badge,

    updateCompanieTracking,
    AssociarVeiculosModal,
  },
  data () {
    return {
      idRole: localStorage.getItem('id_role'),
      schema: '',
      placa: '',
      categoria: '',
      paginationData: {
        currentPage: 1,
        lastPage: 1,
        total: 0,
      },
      schemaOptions: [],
      veiculos: [],
      loaded: false,
      loading: false,
      loadingActions: false,
      trakingCompany: [],
      veiculoSelected: {},
      canAssociarVeiculosAutonomos: useAuth().canAssociarVeiculosAutonomos,
    }
  },
  computed: {
    schemaAutonomo () {
      return isSchemaAutonomo(this.schema)
    },
    statusLegendOptions () {
      const ativos = this.veiculos.filter(v => v.flg_ativo === true).length
      const inativos = this.veiculos.filter(v => v.flg_ativo === false).length

      return [
        { legend: `Ativos - ${ativos}`, color: 'green' },
        { legend: `Inativos - ${inativos}`, color: 'red' },
      ]
    }
  },
  async created () {
    await Promise.all([
      this.fetchCfcs(),
      this.loadTrakingCompany(),
    ])

    this.loaded = true
  },
  methods: {
    openAssociarVeiculosModal () {
      // Já abre com o autônomo consultado, se houver
      this.$refs.associarVeiculosModal.open(this.schemaAutonomo ? this.schema : '')
    },
    async recarregarVeiculos () {
      if (this.schema) {
        await this.fetchVeiculos()
      }
    },
    formatarPeriodo (veiculo) {
      const data = valor => (valor ? valor.substring(0, 10).split('-').reverse().join('/') : '?')
      return `${data(veiculo.data_inicio_utilizacao)} a ${data(veiculo.data_fim_utilizacao)}`
    },
    async fetchCfcs () {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/autoescola`)
        .then((res) => {
          this.schemaOptions = res.body.dados.map(cfc => ({ value: cfc.tenant_schema, text: cfc.nome_fantasia }))
        })
        .catch((error) => {
          this.$toasted.show('Erro:' + error.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async fetchVeiculos (page = 1) {
      this.loading = true

      const params = {
        page: page,
        schema: this.schema,
        placa: this.placa,
        categoria: this.categoria,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/veiculo/consultar`, { params })
        .then((res) => {
          if (res.body.dados.data < 1) {
            this.$toasted.show('Nenhum resultado encontrado!', {
              position: 'top-right',
            })

            return
          }

          this.veiculos = res.body.dados.data

          this.paginationData = {
            currentPage: res.body.dados.current_page,
            lastPage: res.body.dados.last_page,
            total: res.body.dados.total,
          }
        })
        .catch((err) => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async handleSubmit () {
      if (this.validateInputs()) {
        await this.fetchVeiculos()
      }
    },
    validateInputs () {
      if (!this.schema) {
        this.launchToast('Por favor, selecione uma autoescola!')

        return false
      }

      return true
    },
    clearInputs () {
      this.schema = ''
      this.placa = ''
      this.categoria = ''
    },
    launchToast (mensagem) {
      this.$toasted.show(mensagem, {
        position: 'top-right',
      })
    },
    async atualizarVeiculos () {
      if (!this.schema) {
        this.launchToast('Selecione uma autoescola!')
        return
      }

      this.loading = true

      const params = {
        schema: this.schema,
      }

      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/getran/atualizar/veiculos`, { params })
        .then(res => {
          this.launchToast(res.data.mensagem)

          this.fetchVeiculos()
        })
        .catch(error => {
          this.launchToast(error.body.mensagem)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async loadTrakingCompany () {
      await this.$http.get(`${process.env.VUE_APP_URL_API_V2}/rastreameto`)
        .then(response => {
          this.trakingCompany = response.body.dados.map(company => ({ value: company.id, text: company.name }))
        })
        .catch(() => {
          this.toast('Erro ao listar categorias.')
        })
    },
    openModalTrakingCompany (veiculo) {
      this.veiculoSelected = {}
      this.veiculoSelected = veiculo
      this.$refs.trakingModal.open()
    },
    async toggleGpsMobile (veiculo) {
      this.loadingActions = true

      const params = {
        schema: this.schema,
        id: veiculo.id_veiculo,
      }

      await this.$http.patch(`${process.env.VUE_APP_URL_API_V2}/veiculo/rastreameto/active/gps-mobile`, params)
        .then(response => {
          const action = veiculo.ative_gps_apk ? 'desativado' : 'ativado'
          this.launchToast(`GPS via aplicativo ${action} com sucesso!`)

          // Atualiza o status local do veículo
          veiculo.ative_gps_apk = !veiculo.ative_gps_apk
        })
        .catch(error => {
          const errorMessage = error.body.mensagem
          this.launchToast(errorMessage)
        })
        .finally(() => {
          this.loadingActions = false
        })
    },
  },
  watch: {
    schema: {
      handler (newValue, oldValue) {
        // Executa apenas se o valor mudou e não é a primeira vez (evita execução no carregamento inicial)
        if (newValue && newValue !== oldValue) {
          this.handleSubmit()
        }
      },
      immediate: false
    }
  },
}
</script>

<style lang="scss" scoped>
.periodo {
  display: block;
  margin-top: 0.25rem;
  font-size: 0.75rem;
  color: #606264;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
}

.veiculos-container {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;

  .main-form {
    display: flex;
    flex-direction: column;
    gap: 2.5rem;

    .inputs {
      display: flex;
      flex-direction: column;
      gap: 1.5rem;

      .inputs-row {
        display: flex;
        flex-wrap: wrap;
        gap: 1.5rem;

        .input-full {
          flex: 1;
        }
      }
    }

    .buttons {
      align-self: flex-end;

      display: flex;
      gap: 0.5rem;
    }
  }

  .table-container {
    display: flex;
    flex-direction: column;
    gap: 1rem;

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    .actions {
      display: flex;
      align-items: center;

      div {
        padding: 0 0.5rem;
        display: flex;
        justify-content: center;

        &:not(:first-child) {
          border-left: 1px solid #ECECEC;
        }

        &:not(:last-child) {
          border-right: 1px solid #ECECEC;
        }
      }
    }
  }
}
</style>
